import request from '@/utils/request'


// 查询vip充值记录列表
export function listVip(query) {
  return request({
    url: '/user/vip/list',
    method: 'get',
    params: query
  })
}

// 查询vip充值记录分页
export function pageVip(query) {
  return request({
    url: '/user/vip/page',
    method: 'get',
    params: query
  })
}

// 查询vip充值记录详细
export function getVip(data) {
  return request({
    url: '/user/vip/detail',
    method: 'get',
    params: data
  })
}

// 新增vip充值记录
export function addVip(data) {
  return request({
    url: '/user/vip/add',
    method: 'post',
    data: data
  })
}

// 修改vip充值记录
export function updateVip(data) {
  return request({
    url: '/user/vip/edit',
    method: 'post',
    data: data
  })
}

// 删除vip充值记录
export function delVip(data) {
  return request({
    url: '/user/vip/delete',
    method: 'post',
    data: data
  })
}
